import type { IconName } from "../icon";

export enum EmptyStateVariant {
  INLINE = "inline",
  FULL_PAGE = "full-page",
}
export interface EmptyStateProps {
  isBoxed?: boolean;
  hasHapticsOnMount?: boolean;
  iconName?: IconName;
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
  variant?: EmptyStateVariant;
}

export interface EmptyStateEmits {
  (e: "buttonClick", event: MouseEvent): void;
}
